import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import Banner from "../../components/Banner/Banner";
import { validateLoginForm } from "../../utils/validations/formValidations";
import logo from "../../assets/logo.png";
import infinity from "../../assets/login/infinity.png";
import eyeOff from "../../assets/login/eyeOff.png";
import eyeOn from "../../assets/login/eyeOn.png";
import Modal from "../../components/Modal/Modal";
import "./Login.css";
// services
import { authService } from "../../services/login";
import { role } from "../../services/role";
// redux
import { setUser } from "../../store/slices/userSlice";
// utils
import { permissionsService } from "../../utils/permissionsService";
// services
import websocketService from "../../services/websocketService";
import { tokenService } from "../../services/auth/tokenService";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [errorResponse, setErrorResponse] = useState(false);
  const [title, setTitle] = useState({ text: "", highlight: "" });
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    const username = email;
    const { errors, hasErrors } = validateLoginForm({ email, password });
    setErrors(errors);

    if (!hasErrors) {
      try {
        setLoading(true);
        const response = await authService.login({
          username,
          password,
          user_type: "cms",
        });

        // Obtener datos del usuario
        const userData = await authService.getDataUser();
        console.log(userData);
        if (userData.data.status === "success") {
          console.log(userData.data.data.status);
          if (userData.data.data.status !== "active") {
            setTitle({ text: "Error", highlight: "Login" });
            setMessage("The client is now disabled");
            setErrorResponse(true);
            setIsModalOpen(true);
            return;
          }

          // Guardar datos del usuario en Redux
          dispatch(setUser(userData.data.data));
          // Cargar permisos
          allRoles(userData.data.data);
          console.log("***************************");
          console.log(userData.data.data.id);
          console.log("***************************");
          tokenService.setUserId(userData.data.data.id);
          websocketService.initialize(userData.data.data.id);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        }
      } catch (error) {
        setTitle({ text: "Error", highlight: "Login" });
        setMessage(error.response?.data?.detail || "Error to login");
        setErrorResponse(true);
        setIsModalOpen(true);
      } finally {
        setLoading(false);
      }
    }
  };

  const allRoles = async (user) => {
    try {
      const response = await role.getAllRoles();
      if (response.status === "success") {
        const filteredRoles = response.data.filter(
          (role) => role.name === user.roles[0],
        );
        if (filteredRoles.length > 0) {
          const response = await role.getRole(filteredRoles[0].id);
          if (response.status === "success") {
            const modules = response.data.modules.filter((module) => {
              return module.name.split("_").includes("management");
            });
            permissionsService.setPermissionModules(modules);
            permissionsService.setPermissions(response.data.modules);
          }
        }
      }
    } catch (error) {
      throw error;
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <img src={logo} alt="Barterflip Logo" className="logo" />
        <h1 className="welcome-text">
          WELCOME TO <span className="brand-text">BARTERFLIP</span>
        </h1>
        <p className="subtitle">Let's start by entering your details.</p>

        <form onSubmit={handleLogin} className="login-form" noValidate>
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={errors.email}
            required
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            icon={eyeOff}
            iconAlt={eyeOn}
            onChange={(e) => setPassword(e.target.value)}
            error={errors.password}
            required
          />
          <div className="forgot-password">
            <a href="/forgot-password">Forgot password?</a>
          </div>
          <Button fullWidth disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </Button>
          {error && <div className="error-login-message">{error}</div>}
        </form>
      </div>
      <Banner image={infinity} />
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title={title}
        showConfirmButton={false}
        cancelText="Confirm"
        onConfirm={handleModalClose}
        message={message}
        error={errorResponse}
      />
    </div>
  );
};

export default Login;
